import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';

export default function Login({ onLogin }) {
  const [tab, setTab] = useState('login');
  const [resetToken, setResetToken] = useState('');
  const [resetPassword, setResetPassword] = useState('');
  const [resetConfirm, setResetConfirm] = useState('');
  const [forgotEmail, setForgotEmail] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) { setResetToken(token); setTab('reset'); }
  }, []);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ email: '', password: '', name: '', dealerName: '', dealer_type: 'independent', phone: '', city: '', state: '' });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleLogin = async () => {
    setLoading(true); setError('');
    const d = await api.login(form.email, form.password);
    setLoading(false);
    if (d.error) { setError(d.error); return; }
    onLogin(d.token, d.user);
  };

  const handleRegister = async () => {
    setLoading(true); setError('');
    const d = await api.register(form);
    setLoading(false);
    if (d.error) { setError(d.error); return; }
    setTab('login');
  };

  const handleForgot = async () => {
    setLoading(true); setError(''); setSuccessMsg('');
    const r = await fetch('/api/auth/forgot-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: forgotEmail })
    });
    const d = await r.json();
    setLoading(false);
    if (d.error) { setError(d.error); return; }
    setSuccessMsg(d.message);
  };

  const handleReset = async () => {
    if (resetPassword !== resetConfirm) { setError('Passwords do not match'); return; }
    if (resetPassword.length < 8) { setError('Password must be at least 8 characters'); return; }
    setLoading(true); setError('');
    const r = await fetch('/api/auth/reset-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: resetToken, password: resetPassword })
    });
    const d = await r.json();
    setLoading(false);
    if (d.error) { setError(d.error); return; }
    setSuccessMsg('Password reset! You can now sign in.');
    setTimeout(() => { setTab('login'); window.history.replaceState({}, '', '/'); }, 2000);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: 'linear-gradient(135deg, #0f0f0f 0%, #1a0000 100%)' }}>
      <div style={{ background: '#1a1a1a', border: '1px solid #cc0000', borderRadius: 12, padding: 40, width: '100%', maxWidth: 420 }}>
        <img src="/images/rzdms-logo.png" alt="RZ DMS" style={{ width: 180, margin: '0 auto 20px', display: 'block' }} />
        <p style={{ color: '#888', textAlign: 'center', marginBottom: 28 }}>Dealer Management System</p>



        {tab === 'reset' ? (
          <>
            <h3 style={{ color: '#cc0000', marginBottom: 16 }}>Set New Password</h3>
            <div className="form-group"><label>New Password</label><input type="password" value={resetPassword} onChange={e => setResetPassword(e.target.value)} placeholder="At least 8 characters" /></div>
            <div className="form-group"><label>Confirm Password</label><input type="password" value={resetConfirm} onChange={e => setResetConfirm(e.target.value)} placeholder="Repeat password" /></div>
            <button className="btn-red" style={{ width: '100%', padding: 12, fontSize: 15 }} onClick={handleReset} disabled={loading}>{loading ? 'Resetting...' : 'Reset Password'}</button>
            {successMsg && <div style={{ color: '#4caf50', textAlign: 'center', marginTop: 12 }}>{successMsg}</div>}
          </>
        ) : tab === 'forgot' ? (
          <>
            <h3 style={{ color: '#cc0000', marginBottom: 16 }}>Reset Password</h3>
            <p style={{ color: '#888', fontSize: 13, marginBottom: 16 }}>Enter your email and we'll send you a reset link.</p>
            <div className="form-group"><label>Email</label><input type="email" value={forgotEmail} onChange={e => setForgotEmail(e.target.value)} placeholder="you@dealership.com" onKeyDown={e => e.key === 'Enter' && handleForgot()} /></div>
            <button className="btn-red" style={{ width: '100%', padding: 12, fontSize: 15 }} onClick={handleForgot} disabled={loading}>{loading ? 'Sending...' : 'Send Reset Link'}</button>
            {successMsg && <div style={{ color: '#4caf50', textAlign: 'center', marginTop: 12 }}>{successMsg}</div>}
            <div style={{ textAlign: 'center', marginTop: 16 }}><button onClick={() => setTab('login')} style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', fontSize: 13 }}>← Back to Login</button></div>
          </>
        ) : (
          <>
            <div className="form-group"><label>Email</label><input type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="you@dealership.com" onKeyDown={e => e.key === 'Enter' && handleLogin()} /></div>
            <div className="form-group"><label>Password</label><input type="password" value={form.password} onChange={e => set('password', e.target.value)} placeholder="" onKeyDown={e => e.key === 'Enter' && handleLogin()} /></div>
            <button className="btn-red" style={{ width: '100%', padding: 12, fontSize: 15 }} onClick={handleLogin} disabled={loading}>{loading ? 'Signing in...' : 'Sign In'}</button>
            <div style={{ textAlign: 'center', marginTop: 12 }}><button onClick={() => setTab('forgot')} style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', fontSize: 13 }}>Forgot password?</button></div>
          </>
        )}
        {error && <div className="error-msg" style={{ textAlign: 'center', marginTop: 12 }}>{error}</div>}
      </div>
    </div>
  );
}
